export default __webpack_public_path__ + "static/media/mytrees-site.bb931389.png";